import { useEffect, useRef, useState } from 'react';
import { i18n } from 'app/utils/i18n';

import './AddUser.scss';

interface AddUserProps {
  onClick: (user: string) => void;
}

export const AddUser = ({ onClick }: AddUserProps) => {
  const [userName, setUserName] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();

    return () => {
      setUserName('');
    };
  }, []);

  const handleAddUser = (event: React.FormEvent) => {
    event.preventDefault();

    //TODO: validate user here?

    onClick(userName);
    setUserName('');
  };

  return (
    <div className="add-user">
      <form onSubmit={handleAddUser}>
        <input
          type="text"
          name="username"
          value={userName}
          ref={inputRef}
          placeholder={i18n('document-permissions.field.placeholder.new-user')}
          onChange={(event) => setUserName(event.target.value)}
        />

        <button type="submit" className="button btn btn-secondary" disabled={!userName}>
          {i18n('document-permissions.button.new-user')} {userName}
        </button>
      </form>
    </div>
  );
};
